<template>
	<div>
		<div class="searchBox">
			<el-input style='width: 300px;' placeholder="请输入内容" v-model="input10" clearable></el-input>
			<el-button type="primary" icon="el-icon-search" @click='getData()'>搜索</el-button>
		</div>
		<div class="table">
			<el-table :data="tableData" style="width: 100%"  height="calc(100vh - 250px)">
				<el-table-column prop="detail.name" label="姓名">
				</el-table-column>
<!-- 				<el-table-column prop="name" label="常驻地">
				</el-table-column> -->
				<el-table-column label="手机号">
					<template slot-scope='scope'>
						<span>{{scope.row.detail.mobileno || '--'}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="detail.nationalId" label="证件号码">
				</el-table-column>
				<el-table-column label="保障卡号">
					<template slot-scope='scope'>
						<span>{{scope.row.detail.code ||'--'}}</span>
					</template>
				</el-table-column>
				<el-table-column label="序列号">
					<template slot-scope='scope'>
						<span>{{scope.row.codeNo ||'--'}}</span>
					</template>
				</el-table-column>
				<el-table-column label="结算情况">
					<template slot-scope='scope'>
						<span>{{billingState[scope.row.detail.billingState + 1]}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope='scope'>
						<a v-if="scope.row.detail.policyUrl" target="_blank" class="blue" :href="scope.row.detail.policyUrl">查看保单 </a>
						<el-button style='margin-left: 0;' v-else type="text" disabled>查看保单 </el-button>
						<a v-if="scope.row.detail.serviceCredential" target="_blank" class="blue" :href="scope.row.detail.serviceCredential">查看凭证</a>
						<el-button style='margin-left: 0;' v-else type="text" disabled>查看凭证</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fenye">
			<el-pagination class='pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40]"
			 :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="allpage">
			</el-pagination>
		</div>	
	</div>
</template>

<script>
	import { entityDetailList } from '@/axios/api.js'
	export default {
		data() {
			return {
				input10: '',
				billingState:['创建失败','未结账','已结账',' 挂账-未结账','挂账-已结账','已退单（完全退单）'],
				tableData: [],
				allpage:0,//数据总数
				eachPage:10,//每页
				indexPage:0,//当前页	
			}
		},
		methods: {
			handleSizeChange(val) { //console.log(`每页 ${val} 条`);
				this.eachPage = val;
				this.getData()
			},
			handleCurrentChange(val) { //console.log(`当前页: ${val}`);
				this.indexPage = (val-1) * this.eachPage;
				console.log(val)
				this.getData()
			},				
			getData(){
				var data={
					productId:this.$route.query.id,
					isActive:1,
					kw:this.input10,
					start:this.indexPage,
					count:this.eachPage,
				}
				if(data.kw == '') {
					delete data.kw
				}
				entityDetailList(data)
				.then( res => {
				    console.log(res);
					this.tableData=res.data.obj
					this.allpage=res.data.total;
				})
				.catch(err => {
				    console.log(err);
				})
			}
		},
		mounted() {
			this.getData()
		}
	}
</script>

<style scoped="scoped">
	.searchBox {
		margin: 20px 0;
	}
</style>



// WEBPACK FOOTER //
// src/views/card/statisticalDetail.vue